const props = {
  proFormProps: Object,
  proTableProps: Object
}

export const propsKeys = Object.keys(props)

export default props
